// extracted by mini-css-extract-plugin
module.exports =  {"controlButtons":"controlButtons--Sqx1L-5TiKktWQv7xDo46Q=="};